<template>
  <section class="last-page cover--condensed" data-type="last-page">
    <div class="cover__content">
      <div class="cover__image__container">
        <img
          class="cover__image"
          v-if="projectInfo.cover_photo.value.url"
          :alt="projectInfo.cover_photo.value.name"
          :src="projectInfo.cover_photo.value.url">
        <div class="cover__image-placeholder" v-else>
        </div>
      </div>
      <div class="cover__info">
        <div class="info__left">
          <ul class="pl-1">
            <li>
              <div class="title is-4 mb-5">
                Do You Have Any Questions?
              </div>
            </li>
          </ul>
          <div class="details mt-5 pt-5">
            <div>
              <ul><li><div>Learn More</div></li></ul>
              <div class="details__content">
                <a href="https://www.mitrex.com">mitrex.com</a>
              </div>
              <div class="details__content">
                <a href="https://www.cladify.com">cladify.com</a>
              </div>
            </div>
            <div class="mt-2">
              <ul><li><div>Headquarters</div></li></ul>
              <div class="details__content">41 Racine Rd, Etobicoke ON M9W 2Z4</div>
            </div>
          </div>
        </div>
        <div class="info__right">
          <div 
            class="mb-1" 
            v-for="[label, info] in salesPerson"
            :key="label"
          >
            <div class="header">{{ label }}</div>
            <div class="has-text-weight-semibold">{{ info }}</div>
          </div>
          <div class="mb-1">
            <div class="header">Date</div>
            <div class="has-text-weight-semibold">
              {{ formatDate(projectInfo.date.value) }}
            </div>
          </div>
          <div>
            <div class="header">Version</div>
            <div class="has-text-weight-semibold">
              {{ projectInfo.contact.value['Quote No.'] }}
            </div>
          </div>
          <img 
            class="cover__logo" 
            src="../../assets/mitrex_and_cladify_logo.png"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { format } from 'date-fns'

export default {
  props: {
    projectInfo: {
      type: Object,
      required: true
    },
    productBrand: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      formatDate: (date) => {
        return date ? format(date, "MMM dd, yyyy") : null;
      }
    }
  },
  computed: {
    contact({ projectInfo }) {
      return Object.entries(projectInfo.contact.value)
        .filter(c => !['phone', 'quote no.'].includes(c[0].toLowerCase()))
        .map(c => c[0] === 'To' ? ['client', c[1]] : c)
    },
    salesPerson({ projectInfo }) {
      return Object.entries(projectInfo.sales_person.value)
        .filter(c => !['mobile', 'estimator'].includes(c[0].toLowerCase()))
        .map(c => {
          if (c[0] === 'From') {
            return ['Presented By', c[1]]
          } else if (c[0] === 'Phone') {
            return ['Phone Number', c[1]]
          } else {
            return c
          }
        })
    }
  }
}
</script>

<style scoped>
@import '../../styles/cover-page-condensed.css';
</style>
